"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompactStatus = void 0;
exports.instanceOfCompactStatus = instanceOfCompactStatus;
exports.CompactStatusFromJSON = CompactStatusFromJSON;
exports.CompactStatusFromJSONTyped = CompactStatusFromJSONTyped;
exports.CompactStatusToJSON = CompactStatusToJSON;
exports.CompactStatusToJSONTyped = CompactStatusToJSONTyped;
/**
 *
 * @export
 */
exports.CompactStatus = {
    MultiState: 'MULTI_STATE',
    SingleState: 'SINGLE_STATE'
};
function instanceOfCompactStatus(value) {
    for (const key in exports.CompactStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.CompactStatus, key)) {
            if (exports.CompactStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function CompactStatusFromJSON(json) {
    return CompactStatusFromJSONTyped(json, false);
}
function CompactStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CompactStatusToJSON(value) {
    return value;
}
function CompactStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=CompactStatus.js.map